module.exports = __webpack_public_path__ + "img/flags/KI.b89fedc.png";